import React from 'react';
import qs from 'qs';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { InstantSearch, InfiniteHits, SearchBox, Configure } from 'react-instantsearch';
import Cookies from 'js-cookie';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import MsgNetLoading from '../components/MsgNetLoading';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import IconFavoriteBorder from '../icons/IconFavoriteBorder';
import config from '../config';
import SharePanel from '../components/SharePanel';
import TopHeaderMenu from '../components/TopHeaderMenu';

function Participante({ hit, favoritos, onClickFavorito }) {
  const favorito = favoritos.indexOf(hit.dorsal) >= 0;
  return (
    <div className="list-none mb-3">
      <div className="flex items-center gap-3 py-3 bg-slate-900/50 hover:bg-slate-900/70 transition rounded-lg">
        <button
          onClick={() => onClickFavorito(hit.dorsal)}
          className={['flex-shrink-0 w-10 h-10 rounded-lg grid place-items-center transition-all',
            favorito ? 'bg-red-500 hover:bg-red-600' : 'bg-slate-800 hover:bg-slate-700 border border-slate-700'].join(' ')}
        >
          <IconFavoriteBorder fill={favorito ? '#ffffff' : '#94a3b8'} />
        </button>
        <Link to={`/competicion/${hit.competicion_id}/dorsal/${hit.dorsal}`} className="flex-1 min-w-0">
          <div className="truncate text-white font-medium font-montserrat text-base">{hit.nombre} {hit.apellidos}</div>
          <div className="mt-1 text-sm text-slate-400 font-montserrat">
            Dorsal <strong className="text-slate-200">{hit.dorsal}</strong>
            {hit.club && <span> - {hit.club}</span>}
            {hit.localidad && <span> - {hit.localidad}</span>}
          </div>
        </Link>
        <div className="flex-shrink-0 text-slate-500">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Search(props) {
  return (
    <div className="w-full">
      <div className="mx-auto max-w-5xl px-4 md:px-40">
        <div className="mb-6">
          <SearchBox
            placeholder="Busca por nombre, apellidos, dorsal, club..."
            classNames={{
              root: 'w-full', form: 'relative',
              input: 'w-full px-4 py-3 pr-12 bg-slate-900 border border-slate-700 rounded-lg text-white placeholder-slate-500 placeholder:text-sm font-montserrat focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent',
              submit: 'absolute right-3 top-1/2 -translate-y-1/2', submitIcon: 'w-5 h-5 text-slate-400',
              reset: 'absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-lg bg-slate-800 hover:bg-slate-700 border border-slate-700 grid place-items-center transition-colors cursor-pointer',
              resetIcon: 'w-4 h-4 text-slate-400', loadingIndicator: 'absolute right-3 top-1/2 -translate-y-1/2', loadingIcon: 'w-5 h-5 text-slate-400'
            }}
          />
        </div>
        <InfiniteHits showPrevious={false}
          classNames={{ root: 'w-full', list: 'space-y-0', item: 'list-none' }}
          hitComponent={(hitProps) => <Participante hit={hitProps.hit} favoritos={props.favoritos} onClickFavorito={props.onClickFavorito} />}
        />
      </div>
    </div>
  );
}

const urlToSearchState = (location) => {
  const d = qs.parse(location.search, { ignoreQueryPrefix: true });
  return d.query ? { query: d.query } : { query: '' };
};

class FavoritoSearchScreenClass extends React.Component {
  constructor(opts) {
    super(opts);
    this.state = {
      evento: null, competicion: null, favoritos: [],
      searchState: urlToSearchState(this.props.location), showSharePanel: false
    };
  }

  toogleSharePanel() { this.setState({ showSharePanel: !this.state.showSharePanel }); }

  componentDidMount() {
    const competicionId = parseInt(this.props.params.competicionId, 10);
    fetch(`${config.API_URL}/api/1.0/live/${competicionId}/init/`)
      .then(r => r.json())
      .then(data => this.setState({ competicion: data.competicion, evento: data.evento }))
      .catch(err => console.error('live-init error:', err));

    const favoritosCookie = Cookies.get('favoritos-' + competicionId);
    if (favoritosCookie) {
      try { this.setState({ favoritos: JSON.parse(favoritosCookie).map(o => parseInt(o, 10) || null) }); }
      catch (e) { console.error('Error parsing favoritos cookie:', e); }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.setState({ searchState: urlToSearchState(this.props.location) });
    }
  }

  onClickBack() { this.props.navigate(`/${this.state.competicion.evento_id}`); }

  onClickFavorito(dorsal) {
    const competicionId = parseInt(this.props.params.competicionId, 10);
    let favoritos = [...this.state.favoritos];
    const idx = favoritos.indexOf(dorsal);
    if (idx >= 0) { favoritos.splice(idx, 1); } else { favoritos.push(dorsal); }
    this.setState({ favoritos });
    Cookies.set('favoritos-' + competicionId, JSON.stringify(favoritos), { path: '/', expires: 30 });
  }

  render() {
    const { competicion, evento, showSharePanel } = this.state;
    if (!competicion) return <MsgNetLoading />;
    return (
      <div>
        <TopHeaderMenu onClickBack={this.onClickBack.bind(this)} onClickShare={this.toogleSharePanel.bind(this)} competicion={competicion} evento={evento} />
        <CompeticionHeaderMenu competicion={competicion} selected={4} evento={evento} />
        <div className="pt-28">
          <div className="flex justify-center mb-3">
            <div className="w-fit rounded-lg px-4 py-2 text-sm font-light tracking-wide text-center ring-1 font-montserrat ring-slate-700 text-slate-300 mx-4">
              Busca y añade atletas a tu lista de favoritos para seguirlos en tiempo real
            </div>
          </div>
          {competicion.visible && (
            <InstantSearch
              searchClient={algoliasearch(config.ALGOLIA_APP_ID, config.ALGOLIA_SEARCH_KEY)}
              indexName={config.ALGOLIA_INDEX_NAME}
              initialUiState={{ [config.ALGOLIA_INDEX_NAME]: this.state.searchState }}
              onStateChange={({ uiState }) => { this.setState({ searchState: uiState[config.ALGOLIA_INDEX_NAME] || {} }); }}
            >
              <Configure filters={`competicion_id = ${this.props.params.competicionId}`} />
              <Search favoritos={this.state.favoritos} onClickFavorito={this.onClickFavorito.bind(this)} />
            </InstantSearch>
          )}
        </div>
        {showSharePanel && (
          <SharePanel close={this.toogleSharePanel.bind(this)}
            url={`/competicion/${competicion.id}/favoritos`}
            title={`Buscar favoritos en la prueba ${competicion.nombre} en ${evento.nombre}`}
          />
        )}
      </div>
    );
  }
}

function FavoritoSearchScreen() {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  return <FavoritoSearchScreenClass navigate={navigate} params={params} location={location} />;
}

export default FavoritoSearchScreen;
